import { render, staticRenderFns } from "./ClientAppList.vue?vue&type=template&id=2b892c71&"
import script from "./ClientAppList.vue?vue&type=script&lang=ts&"
export * from "./ClientAppList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports